<template>
  <div>
    <div v-if="searched" class="header">Refine Results</div>
    <div v-else class="label"><span class="level-left">Filters:</span></div>
    <b-collapse :open="true" aria-id="gradeLevel" class="filter">
      <button
        class="button is-link"
        slot="trigger"
        aria-controls="gradeLevel"
        v-on:click="filterGrade = !filterGrade"
        v-bind:class="{ 'button-filter': searched }"
      >
        <span v-bind:class="{ title: searched }">Grade Level</span>
        <b-icon v-if="!filterGrade" icon="plus-box-outline"></b-icon>
        <b-icon v-else icon="minus-box-outline"></b-icon>
      </button>
      <div
        class="field"
        v-bind:class="{ columns: !searched }"
        v-on:change="updateGradeLevel"
      >
        <div v-bind:class="{ column: !searched }">
          <div v-for="(item, index) in filterTerms.grade" :key="index">
            <b-checkbox
              v-if="index < 3"
              v-model="filters.gradeChecked"
              :native-value="item.id"
              >{{ item.name }}</b-checkbox
            >
          </div>
        </div>
        <div v-bind:class="{ column: !searched }">
          <div v-for="(item, index) in filterTerms.grade" :key="index">
            <b-checkbox
              v-if="index > 2"
              v-model="filters.gradeChecked"
              :native-value="item.id"
              >{{ item.name }}</b-checkbox
            >
          </div>
        </div>
      </div>
    </b-collapse>
    <b-collapse :open="false" aria-id="subject" class="filter">
      <button
        class="button is-link"
        slot="trigger"
        aria-controls="subject"
        v-on:click="filterSubject = !filterSubject"
        v-bind:class="{ 'button-filter': searched }"
      >
        <span v-bind:class="{ title: searched }">Subject</span>
        <b-icon v-if="!filterSubject" icon="plus-box-outline"></b-icon>
        <b-icon v-else icon="minus-box-outline"></b-icon>
      </button>
      <div
        class="field"
        v-bind:class="{ columns: !searched }"
        v-on:change="updateSubject"
      >
        <div v-bind:class="{ column: !searched }">
          <div v-for="(item, index) in filterTerms.subject" :key="index">
            <b-checkbox
              v-if="index < 4"
              v-model="filters.subjectChecked"
              :native-value="item.id"
              >{{ item.name }}</b-checkbox
            >
          </div>
        </div>
        <div v-bind:class="{ column: !searched }">
          <div v-for="(item, index) in filterTerms.subject" :key="index">
            <b-checkbox
              v-if="index > 3 && index < 8"
              v-model="filters.subjectChecked"
              :native-value="item.id"
              >{{ item.name }}</b-checkbox
            >
          </div>
        </div>
        <div v-bind:class="{ column: !searched }">
          <div v-for="(item, index) in filterTerms.subject" :key="index">
            <b-checkbox
              v-if="index > 7"
              v-model="filters.subjectChecked"
              :native-value="item.id"
              >{{ item.name }}</b-checkbox
            >
          </div>
        </div>
      </div>
    </b-collapse>
    <b-collapse :open="false" aria-id="type" class="filter">
      <button
        class="button is-link"
        slot="trigger"
        aria-controls="type"
        v-on:click="filterType = !filterType"
        v-bind:class="{ 'button-filter': searched }"
      >
        <span v-bind:class="{ title: searched }">Type</span>
        <b-icon v-if="!filterType" icon="plus-box-outline"></b-icon>
        <b-icon v-else icon="minus-box-outline"></b-icon>
      </button>
      <div
        class="field"
        v-bind:class="{ columns: !searched }"
        v-on:change="updateType"
      >
        <div v-bind:class="{ column: !searched }">
          <div v-for="(item, index) in filterTerms.type" :key="index">
            <b-checkbox
              v-if="index < 3"
              v-model="filters.typeChecked"
              :native-value="item.id"
              >{{ item.name }}</b-checkbox
            >
          </div>
        </div>
        <div v-bind:class="{ column: !searched }">
          <div v-for="(item, index) in filterTerms.type" :key="index">
            <b-checkbox
              v-if="index > 2"
              v-model="filters.typeChecked"
              :native-value="item.id"
              >{{ item.name }}</b-checkbox
            >
          </div>
        </div>
      </div>
    </b-collapse>
    <b-collapse :open="false" aria-id="location" class="filter">
      <button
        class="button is-link"
        slot="trigger"
        aria-controls="location"
        v-on:click="filterLocation = !filterLocation"
        v-bind:class="{ 'button-filter': searched }"
      >
        <span v-bind:class="{ title: searched }"
          >Location of Featured Work of Art</span
        >
        <b-icon v-if="!filterLocation" icon="plus-box-outline"></b-icon>
        <b-icon v-else icon="minus-box-outline"></b-icon>
      </button>
      <div class="field" v-bind:class="{ columns: !searched }">
        <div v-bind:class="{ column: !searched }">
          <div v-for="(item, index) in filterTerms.location" :key="index">
            <b-checkbox
              v-model="filters.locationChecked"
              :native-value="item.id"
              >{{ item.name }}</b-checkbox
            >
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "SearchMusEdFilters",
  data() {
    return {
      filterGrade: true,
      filterSubject: false,
      filterType: false,
      filterLocation: false
    };
  },
  props: {
    searched: Boolean,
    filters: {
      name: Object,
      default: () => ({
        gradeChecked: [],
        subjectChecked: [],
        typeChecked: [],
        locationChecked: []
      })
    },
    filterTerms: Object
  },
  methods: {
    updateGradeLevel() {
      this.$emit("update:inputGrade", this.filters);
    },
    updateSubject() {
      this.$emit("update:inputSubject", this.filters);
    },
    updateType() {
      this.$emit("update:inputType", this.filters);
    },
    updateLocation() {
      this.$emit("update:inputLocation", this.filters);
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  background: #7d7d7d;
  text-transform: uppercase;
  color: #fff;
  font-size: $size-7;
  text-align: left;
  padding: 0.25em 0.75em;
}
.field {
  &:not(.columns) {
    padding: 0.5em 0;
    background: #f5f5f5;
    label {
      width: 100%;
      margin: 0 0.75em !important;
      text-align: left;
      font-size: $size-7;
    }
  }
  .column {
    width: 100%;
    .checkbox {
      margin-left: 0.5em;
      width: 100%;
    }
  }
}
.collapse-content {
  .columns {
    margin: 0;
    background: #f5f5f5;
  }
}
.collapse-trigger {
  button {
    width: 100%;
    &.button-filter {
      vertical-align: middle;
      .title {
        font-size: $size-7;
        word-break: break-word;
        white-space: normal;
        line-height: 1;
        margin-bottom: 0;
      }
    }
    &.is-link {
      background: #e1e1e1;
      color: black !important;
      border-radius: 0;
      &:hover {
        background: darken(#e1e1e1, 5%);
        color: black;
      }
    }
    span {
      text-align: left;
      width: 97%;
      font-weight: 600;
    }
  }
}
</style>
